export function clear (group) {
    group.querySelectorAll('[data-tab]').forEach((tab) => {
        tab.classList.remove('active');
    });

    group.querySelectorAll('[data-body]').forEach((tab) => {
        tab.classList.remove('active');
    });
}

function selectTab (group, tab) {
    const body = group.querySelector(`[data-body="${tab.dataset.tab}"]`);
    body.classList.add('active');
    tab.classList.add('active');
}


export default function (selector) {
    const tabgroups = document.querySelectorAll(selector);

    tabgroups.forEach((tabgroup) => {
        tabgroup.querySelectorAll('[data-tab]').forEach((tab) => {
            tab.addEventListener('click', (e) => {
                e.preventDefault();
                clear(tabgroup);
                selectTab(tabgroup, tab);
            });
        });
    });
}